export const getElement = (selector: string) => document.querySelector(selector);
